import { Button, withStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Text } from "react-internationalization";
import ProspectGuidelines from "../Guidelines/ProspectGuidelines"
import { Styles } from "../../../assests/styles/DashboradStyles";
import SelectedFileTable from "./SelectedFileTable";
import DataTable from "../../../Utils/GenericUI/DataTable";
import AutoComplete1 from "../../../Utils/Select";
import { CSVLink } from "react-csv";
import CsvReader from "../../../Utils/Excel/CsvReader";
import {
  ProspectManagementSaveProspect,
  searchProspect,
  loadProspectFilesData,
  prospectFileData,
  getAgentList,
  loadCampaignNames
} from "../../../Redux/Actions/webAppActions";

import { formatPhoneNumber } from "../../../Utils/DateFormatter";
import { BulkHeader } from "../../../Utils/StaticData/DashboardHeader";
import { connect } from "react-redux";
import { useSelector, useDispatch } from "react-redux";

const ProspectBulkUpload = (props) => {
  const [newAddUsers, setNewAddUsers] = React.useState([]);
  const [ProspectBulkData, setProspectBulkData] = useState([]);
  const [rowCount] = React.useState(0);
  const [selectedFile, setSelectedFile] = useState("All");
  const [selectedFilestatus, setSelectedFilestatus] = useState("All");
  const [SelectedFileId, setSelectedFileId] = useState("All");


  const [rowsPerPage, setrowsPerPage] = React.useState(5);

  const [selectedRowIndex, setselectedRowIndex] = React.useState(0);
  const prospectUplodedFiles = useSelector((state) => state.bulk.prospectUplodedFiles);
  const [payObj, setpayObj] = useState({
    planCampaignId: [],
    assignedTo: "",
  });

  const dispatch = useDispatch();

  const goBack = async () => {
    setSelectedFile("All");
  };
  const columnSelected = async (fileName, fileId, status) => {
    //call api to load the data for a particular file in the pop up
    await dispatch(
      prospectFileData({
        fileId: fileId,
        status: status,
      })
    );
    setSelectedFile(fileName);
    setSelectedFilestatus(status);

    setSelectedFileId(fileId);
  };
  const rowSelect = async (index, selectedData, rowsPerPage1, type) => {
    setrowsPerPage(rowsPerPage1);
    setselectedRowIndex(index);
  };

  const handleChangeRowsPerPage = async (rowsPerPage2) => {
    setrowsPerPage(rowsPerPage2);
  };

  const setdataVal = async (name, value, payObj1, index) => {
    let tempArr = JSON.parse(JSON.stringify(newAddUsers));
    if (name === "phone" || name === "secPhoneNbr") {
      tempArr[index][name] = formatPhoneNumber(value);
    } else {
      tempArr[index][name] = value;
    }
    setNewAddUsers(tempArr);
  };

  const handlechange = (name, index) => async (event) => {
    //let value = event.target.value;
    let value = event.target ? event.target.value : event.value || event.label;
    if (event.target?.name === "del") {
      value = event.target.value === "Y" ? "N" : "Y";
    }
    if (name.includes("assignedTo")) {
      value = event?.label;
     
      setpayObj({
        ...payObj,
        assignedTo: value,
        assignedToEventvalue:event?.value
      });

      return;
    }
    if (name.includes("planCampaignId")) {
      setpayObj({
        ...payObj,
        planCampaignId: value,
      });
      return;
    }
    // if (name === "firstName" || name === "lastName") {
    //   // if(value.match("^[A-Za-z]+$")){
    //   value = value.replace(/[^a-z-A-Z- --]/g, "");
    //   setdataVal(name, value, payObj, index);
    //   // }
    // }
    else {
      setdataVal(name, value, payObj, index);
    }
  };

  // in useeffect call the api to load main bulk and store in bulk data
  useEffect(() => {
    const user = async () => {
      const res = await dispatch(loadProspectFilesData());
      //console.log("clsbulk1",res.data)
      if (res?.status === "OK") {
        await setProspectBulkData(res?.data);
      }
    };
    user();
  }, []);
  useEffect(() => {
    setProspectBulkData(prospectUplodedFiles);
  }, [prospectUplodedFiles]);
useEffect(()=>{
  
    if (
      props?.prospectagentList?.length <= 1 ||
    props?.prospectagentList === undefined
    ) {
      dispatch(getAgentList(props?.customerId));
    }

    if (
      props?.campaignName?.length <= 1 ||
      props?.campaignName === undefined
    ) {
      dispatch(loadCampaignNames());
    }
  
},[])

const handleMultipleSelectionDropdown = (name) => async (data) => {
  let multipleValues = [];
  data.forEach((data1) => {
    multipleValues.push(data1.value);
  });
  // console.log("test--",data,multipleValues)
  // if(name==="planCampaignId"){
    if(multipleValues?.length>5){
      props.handleSnackbar(
        "Maximum 5 campaigns can be added.",
        "warning",
      );
    return;
  }
  let occurance={}
  multipleValues.forEach((ele)=>{
    if(occurance[ele]){
      occurance[ele]+=1;
    }else{
      occurance[ele]=1;
    }
  })
  if(Object.values(occurance).some((e)=>e===2)){
    props.handleSnackbar(
      "Campaign is already added.",
      "warning",
    );
    return;
  }
  // }
  await setpayObj({
    ...payObj,planCampaignId:multipleValues
  });
};
  return (
    <React.Fragment>
      <div 
     // style={{ marginTop: "1rem", marginLeft: "1rem" }}
      >
        {selectedFile === "All" ? (
          <div class="container-campaignmain prospecttablealign mt-3 mb-3">
            <div class="text-justify">
              <span class="label-container">
                <label for="prospect_gender" class="labelprospect">
                  Assigned To <span class="mandatory-field">*</span>
                </label>
                <br />

                <AutoComplete1
                  width={"260px"}
                  dashboard="bulkUploadProspect"
                  error={payObj.assignedTo === ""||payObj.assignedTo ==="---Select---" ||payObj.assignedTo ==="Select"}
                  handleChange={handlechange("assignedTo")}
                  options={props.prospectagentList}
                  value={
                    props.prospectagentList?.length > 1 &&
                    props.prospectagentList.filter(
                      (data1) => data1.label === payObj.assignedTo
                    ).length !== 0
                      ? props.prospectagentList.filter(
                          (data1) => data1.label === payObj.assignedTo
                        )[0]
                      : {
                          label: "select",
                          value: "",
                        }
                  }
                  name="assignedTo"
                  id="assignedTo"
                />
              </span>
              <span class="label-container">
                <label for="prospect_gender" class="labelprospect">
                  Plan Campaign Name <span class="mandatory-field">*</span>
                </label>
                <br />

                <AutoComplete1
                  width={"260px"}
                  dashboard="bulkUploadProspect"
                  error={payObj.planCampaignId?.length===0}
                  handleChange={handleMultipleSelectionDropdown("planCampaignId")}
                  options={props.campaignName.filter((e)=>payObj.planCampaignId.some((id)=>id===e?.value)===false)}
                  value={
                    // props.campaignName.filter(
                    //   (data1) => data1.value === payObj.planCampaignId
                    // ).length !== 0
                    // payObj.planCampaignId?.length>0
                       props.campaignName.filter(
                          (data1) => payObj.planCampaignId.some((id)=>id===data1?.value)===true
                        )
                      // : []
                  }
                  defaultValue={{label:"select",value:""}}
                  name="planCampaignId"
                  id="planCampaignId"
                  multiple={true}
                />
              </span>
            </div>
            <div className="Fieldcontainer text-justify">
              <div>
              <Text>
                Please follow the desired format while uploading a bulk list of
                prospects.
                <div></div>
                For quick reference,{"   "}
              </Text> 
              <a href={require("./sampleprospect.csv")} download={"sampleprospect.csv"}>click here{"  "}</a>
              <Text>to view a template.</Text>
              </div>
              
              <div class="mt-2">
                  <ProspectGuidelines/>
                  </div>
              <CsvReader
                assignedTo={payObj.assignedTo}
                assignedToEventvalue={payObj.assignedToEventvalue}
                planCampaignId={payObj.planCampaignId}
                // setData={setData}
                bulkUploadProspect={true}
                bulkUploadCampaign={false}
                disabled={
                  payObj.assignedTo === "" ||
                  payObj.assignedTo ==="---Select---" ||
                  payObj.assignedTo ==="Select" ||
                  payObj.planCampaignId?.length===0
                }
              />
            </div>

            <div 
            class="pt-1" style={{ overflow: "auto" }}
            >
              <DataTable
                //modalSelect={"#BulkModalProspect"}
                //width="max-content"
                width="100%"
                //padding="4px 45px 4px 8px"
                padding="4px 20px 4px 4px"
                dashboard="BulkUploadMainProspect"
                headerPadding="8px 12px 9px 47px"
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={[5, 10, 15]}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                clicked={rowSelect}
                columnSelected={columnSelected}
                setClick={(x) => {}}
                index={selectedRowIndex}
                sortable={true}
                searchable={true}
                header={BulkHeader}
                rowcount={rowCount}
                data={ProspectBulkData}
                exportAsExcel={true}
                // clickedFirst={this.prospectrowSelectFirst}
              />
            </div>
          </div>
        ) : (
          <SelectedFileTable
            dashboard="ProspectBulkUploadModal"
            rowcount={rowCount}
            newAddUsers={newAddUsers}
            selectedFile={selectedFile}
            selectedFilestatus={selectedFilestatus}
            SelectedFileId={SelectedFileId}
            goBack={goBack}
          />
        )}
      </div>
    </React.Fragment>
  );
};
const mapStateToProps = (state) => {
  return {
    customerId: state.login.customerId,
    // prospectagentList: state.campaignProspect.agentList,
    prospectagentList: state.webApp.membershipAgentList,
    campaignName: state.campaignProspect.campaignNamesList,
  };
};
const mapDispatchToProps = {
  ProspectManagementSaveProspect,
  searchProspect,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(Styles)(ProspectBulkUpload));
